var exports = {
  "NJ": "x24da60e8--1c1555--file",
  "Fb": "x24da60e8--1c1555--file-icon",
  "Qs": "x24da60e8--1c1555--content",
  "vn": "x24da60e8--1c1555--file-name",
  "z3": "x24da60e8--1c1555--error",
  "jy": "x24da60e8--1c1555--file-size",
  "gw": "x24da60e8--1c1555--progress-bar",
  "hn": "x24da60e8--1c1555--icon-button",
};

module.exports = exports;
